import { z } from "zod";

import { type FunctionObjectReturn } from "../utils";

export interface AdminContentDurationResult {
  meditationDurationInSeconds: number;
  audioCoursesDurationInSeconds: number;
  publishedMeditationCount: number;
  publishedAudioCourseLessonCount: number;
}

export type AdminContentDurationResponse = FunctionObjectReturn<AdminContentDurationResult>;

export interface AdminOfflineDownloadsCountResult {
  currentCount: number;
  currentUsersCount: number;
  allStoredCount: number;
  cutoffUtc: string;
  ttlDays: number;
}

export type AdminOfflineDownloadsCountResponse = FunctionObjectReturn<AdminOfflineDownloadsCountResult>;

export interface AdminFeedbackMetric {
  label: string;
  value: string;
}

export interface AdminFeedbackWrittenEntry {
  id: string;
  text: string;
  createdAt: string;
}

export interface AdminFeedbackResultsResult {
  totalFeedbackCount: number;
  recommendedCount: number;
  metrics: AdminFeedbackMetric[];
  writtenFeedbacks: AdminFeedbackWrittenEntry[];
}

export type AdminFeedbackResultsResponse = FunctionObjectReturn<AdminFeedbackResultsResult>;

export const AdminUserLookupRequestSchema = z.object({
  identifier: z.string().min(1, { message: "UID oder E-Mail ist erforderlich" }),
});

export type AdminUserLookupRequest = z.infer<typeof AdminUserLookupRequestSchema>;

export interface AdminUserDocumentReportRow {
  label: string;
  value: string;
}

export interface AdminUserDocumentReportEntry {
  primary: string;
  secondary?: string;
  meta?: string;
}

export interface AdminUserDocumentReportResult {
  uid: string;
  authSummary: AdminUserDocumentReportRow[];
  authRecord: Record<string, unknown>;
  profileSummary: AdminUserDocumentReportRow[];
  recommendations: AdminUserDocumentReportEntry[];
  favorites: AdminUserDocumentReportEntry[];
  watched: AdminUserDocumentReportEntry[];
  activity: AdminUserDocumentReportEntry[];
  activityLimit: number;
}

export type AdminUserDocumentReportResponse = FunctionObjectReturn<AdminUserDocumentReportResult>;

export interface AdminSetUserMailVerifiedResult {
  uid: string;
  emailVerified: boolean;
}

export type AdminSetUserMailVerifiedResponse = FunctionObjectReturn<AdminSetUserMailVerifiedResult>;
